import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { CustomInputNumberWrapper, CustomInputNumberWrapperProps, InputControls } from '..';
import { CustomFormItem } from '../../../custom_shared/components';
import { InputModel } from '../../models';
import { InputWithMeta } from '../../componentTypes';

// Please note that this is a generic component if behavior for your input is different - create a new independent component (like BusinessTypeInput.tsx etc.)

type Props = CustomInputNumberWrapperProps & {
    message?: string;
};

const GenericNumberInput: InputWithMeta<Props> = (props: Props) => {
    const { input, message, ...rest } = props;

    return (
        <CustomFormItem name={input.guid} required={input.required} message={message} isReadOnly={input.isReadOnly}>
            <CustomInputNumberWrapper input={input} topRightNode={<InputControls input={input} />} {...rest} />
        </CustomFormItem>
    );
};

GenericNumberInput.meta = {
    inputType: InputModel.name
};

export default observer(GenericNumberInput);
